"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Errors = void 0;
var Errors;
(function (Errors) {
    Errors["emailExists"] = "Email already exists";
    Errors["userNameExists"] = "User name already exists";
    Errors["userNotFound"] = "User not found";
    Errors["passwordIncorrect"] = "Password is incorrect";
    Errors["passwordExpired"] = "Password is expired";
    Errors["userNotVerified"] = "User not verified";
    Errors["appExists"] = "App already exists";
    Errors["appNotFound"] = "App not found";
    Errors["appForbidden"] = "You are not allowed to access this app";
    Errors["invalidEmail"] = "Invalid email";
    Errors["invalidUrl"] = "Invalid url";
    Errors["notAllowed"] = "Not allowed";
    Errors["passwordsDoNotMatch"] = "Passwords do not match";
    Errors["organizationNotFound"] = "Organization not found";
    Errors["orgNameExists"] = "Organization name already exists";
    Errors["passwordRequired"] = "Password is required for this app";
    Errors["requestAlreadyExist"] = "Request already exist";
})(Errors || (exports.Errors = Errors = {}));
